module.exports = __webpack_public_path__ + "img/Icone_200.0995614b.svg";